import { ViewChild, ElementRef, Directive, Renderer2, Injector } from '@angular/core';
import { DropdownBase } from './dropdown-base';
import { DetectDevicesService } from '@fi-shared/fi-shared-services';

@Directive()
export class DropdownBaseWithFilter extends DropdownBase {
    constructor(
        injector: Injector,
        renderer: Renderer2,
        elementRef: ElementRef,
        protected detectDevices: DetectDevicesService,
    ) {
        super(injector, renderer, elementRef);
    }

    @ViewChild('filterElement', { static: false }) filterElement: ElementRef;
    filterText: string = '';

    public openDropdown() {
        super.openDropdown();
        if (!this.detectDevices.isMobilePhone()) {
            setTimeout(() => this.filterElement.nativeElement.focus());
        }
    }

    public closeDropdown() {
        super.closeDropdown();
        if (this.filterText) {
            this.filterText = '';
            this.filterChange();
        }
    }

    public filterChange() {}
}
